import {FC} from "react";
import cls from "../builder.module.scss";

interface IProps {
    item: {
        textEditorValue: string;
        customClassNames: string;
        convertedSettings: {
            animationAos: { "data-aos": any },
            styles: any;
            parentStyles: any
        }
    }
}

const Editor: FC<IProps> = (
    {
        item: {
            textEditorValue,
            customClassNames,
            convertedSettings: {
                animationAos: {"data-aos": dataAos = null} = {},
                styles = {},
                parentStyles = {}
            } = {}
        }
    }
) => {
    return (
        <div data-aos={dataAos} className={customClassNames} style={parentStyles}>
            <div className={cls.editor_content} style={styles} dangerouslySetInnerHTML={{ __html: textEditorValue }}/>
        </div>
    );
};

export default Editor;